export const slugify = (value: string): string =>
  value
    .toLowerCase()
    .trim()
    .normalize('NFKD')
    .replace(/\p{M}/gu, '') // strip accents (combining marks left by NFKD)
    .replace(/[^a-z0-9]+/g, '-') // non-alphanumerics -> hyphen
    .replace(/^-+|-+$/g, ''); // trim leading/trailing hyphens